import { chunk } from '../../../utils/arrayUtil';
import {
  fundOverviewData,
  nfoOverviewData,
} from '../../singleFund/singleFundConst';
import { DetailBlocks } from './detailBlocks';
import { SubHeading } from '../../common/subHeading';

export const FundOverView = ({ fundData, isMobile }) => {
  const { isNfo } = fundData;
  let fundOverViewArr = isNfo
    ? nfoOverviewData(fundData)
    : fundOverviewData(fundData);
  if (fundOverViewArr.length > 4) {
    fundOverViewArr = isMobile
      ? chunk(fundOverViewArr, 2)
      : chunk(fundOverViewArr, 3);
  } else {
    fundOverViewArr = isMobile ? chunk(fundOverViewArr, 2) : [fundOverViewArr];
  }
  return (
    <div className={`${!isNfo && 'lil-mt-12'}`}>
      {!isNfo && <SubHeading title="Fund overview" />}
      <div
        className={`lil-border-dashed lil-border-grey-350 lil-border-sm lil-rounded-xl ${!isNfo &&
          'lil-mt-6'}`}
      >
        {fundOverViewArr.map((row: any, index) => {
          return (
            <div className="lil-border-dashed lil-border-grey-350 lil-flex lil-rounded-r-lg">
              {row.map((ele, eleIndex) => {
                let classes;
                if (eleIndex !== row.length - 1) {
                  classes = 'lil-border-r-sm';
                }
                if (index !== fundOverViewArr.length - 1 && isMobile) {
                  classes = `${classes} lil-border-b-sm`;
                }
                if (index === 0 && !isMobile) {
                  classes = `${classes} lil-border-b-sm`;
                }

                return (
                  <DetailBlocks
                    {...ele}
                    className={`${
                      isMobile ? 'lil-w-1/2' : 'lil-w-4/12 '
                    }  ${classes}`}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/fundOverview/index.tsx